import { initInputCountry } from "../components/input-country";
import '../scss/input-country.scss';

initInputCountry();
